<template>
    <div>
        <div>
            <v-data-table :items="questions" :headers="questionsHeaders" disable-pagination disable-sort hide-default-footer mobile-breakpoint="768" class="v-data-table--default">
                <router-link slot="item.subject" slot-scope="{item}" :to="`/center/questions/${item._id}`" class="d-block font-weight-medium text-truncate">{{ item.subject }}</router-link>
                <span slot="item.no" slot-scope="{item}">{{ (page - 1) * limit + +questions.indexOf(item) + 1 }}</span>
                <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                <span slot="item.answer" slot-scope="{item}">
                    <span v-if="item.answer">답변</span>
                    <span v-else>미답변</span>
                </span>
                <span slot="item.actions" slot-scope="{item}">
                    <div class="v-btn--group--x-small">
                        <v-btn v-if="item.answer" @click="details(item)" x-small color="grey">답변</v-btn>
                        <v-btn v-else @click="edit(item)" x-small color="secondary">수정</v-btn>
                        <v-btn @click="remove(item)" x-small outlined class="white" style="border-color:#9e9e9e!important;"><span class="grey--text text--darken-3">삭제</span></v-btn>
                    </div>
                </span>
            </v-data-table>
        </div>

        <div class="mt-30px mt-md-40px">
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
        </div>

        <div class="mt-20px mt-md-30px">
            <v-row class="row--x-small">
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-btn @click="create" large color="primary" style="border-color:#9e9e9e!important;">작성하기</v-btn>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import { mdiForum, mdiChatQuestion } from "@mdi/js";

import PaginationComponent from "@/components/client/control/pagination-component.vue";

export default {
	components: {
        PaginationComponent
	},
    data() {
        return {
            mdiForum,
            mdiChatQuestion,

            filter: {
                searchKey: 'subject',
                searchValue: '',
                type: ''
            },

            page: 1,
            pageCount: 0,
            limit: 20,

            questions: [],
            questionsHeaders: [
                { text: "No", value: "no", align: "center", width: "8%" },
                { text: "문의제목", value: "subject", align: "left", width: "60%" },
                { text: "답변여부", value: "answer", align: "center", width: "10%" },
                { text: "문의일자", value: "createdAt", align: "center", width: "14%" },
                { text: "-", value: "actions", align: "center", width: "8%" },
            ],
            questionTypes: [
                "회원정보 문의",
                "주문/결제 문의",
                "상품 문의",
                "배송 문의",
                "교환/반품 문의",
                "이벤트/혜택 문의",
                "서비스 개선 의견",
                "기타문의"
            ]
        };
    },
	mounted() {
		this.init();
	},
	methods: {
		init() {
            this.search();
            this.$nextTick(() => {
                // 문의내역 - 답변 토글
                (function(){
                    let question = document.querySelectorAll('.board-table--inquiry [role="button"]'),
                    answer = document.querySelectorAll('.board-table--inquiry [role="rowgroup"].answer');

                    for(let i = 0; i < question.length; i++)
                    question[i].addEventListener('click', toggleInquiry);

                    function toggleInquiry(){
                        let idx = this.getAttribute('data-idx'),
                        toggle = document.querySelector('.board-table--inquiry [role="rowgroup"][data-idx-answer="'+idx+'"]');

                        if(toggle !== null){
                            if(toggle.getAttribute('data-answer') === 'opened'){
                                for(let i = 0; i < answer.length; i++)
                                answer[i].removeAttribute('data-answer');
                            } else {
                                for(let i = 0; i < answer.length; i++)
                                answer[i].removeAttribute('data-answer');
                                toggle.setAttribute('data-answer', 'opened');
                            }
                        }
                    }
                })();
            });
		},

        create(){
            this.$router.push(`${this.$route.path}/create`);
        },

        edit(question){
            this.$router.push(`${this.$route.path}/${question._id}/edit`);
        },

        details(question){
            this.$router.push(`${this.$route.path}/${question._id}`)
        },

        async remove(question){
            if(await this.$confirm("삭제하시겠습니까?")){
                await api.v1.me.center.questions.delete(question);
                await this.search(false);
            }
        },


        async search(){
            var { summary, questions } = await api.v1.me.center.questions.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.questions = questions;
        },
	},
}
</script>

<style scoped>
@media (max-width:1024px){
}
@media (max-width:992px){
}
@media (max-width:600px){
    >>>.v-data-table--default table >tbody >tr >*:nth-child(1){display:none !important;}
    >>>.v-data-table--default table >tbody >tr >*:nth-child(3),
    >>>.v-data-table--default table >tbody >tr >*:nth-child(4),
    >>>.v-data-table--default table >tbody >tr >*:nth-child(5){
        display: inline-block !important;
        border-bottom: none !important;
    }
    >>>.v-data-table .v-data-table__mobile-table-row>.v-data-table__mobile-row:last-child{
        border-bottom: none !important;
    }
    >>>.v-data-table--default>.v-data-table__wrapper>table>tbody>tr{
        border-bottom:1px solid #bdbdbd !important;
    }
}
@media (max-width:576px){
}
</style>